











































































































































































































































































































































































































































































































































import { Quotation, QuotationLine, QuotationRevision } from "@/models";
import { Mixins, Component, Prop } from "vue-property-decorator";
import ExportsMixin from "@/mixins/http/ExportsMixin";
import { LINES_INCLUDES } from "@/utils/Constants";
import { currentUserStore } from "@/store/typed";
import VDot from "@/components/VDot.vue";
import Percent from "@/filters/Percent";
import { flatToTree } from "@/configurator/utils";
import { Product } from "../../models";
import { quotationStore } from "../../store/typed";

const GET_REVISION_TAG = "get_revision";

@Component({ components: { VDot }, filters: { Percent } })
export default class PrintRevision extends Mixins(ExportsMixin) {
  quotation: Quotation | null = null;
  revision: QuotationRevision | null = null;
  screenshotLines: QuotationLine[] = [];

  mounted() {
    this.loadRevision(this.$route.params.revision_id);
  }

  productDescription(product: Product) {
    const langCode = this.quotation.language.shortName;
    return product.descriptionByLang(langCode);
  }

  async loadRevision(id: string) {
    this.revision = await this.getExport(id, GET_REVISION_TAG);
    this.quotation = this.revision.quotation;
    this.$i18n.locale = this.quotation.language.shortName;
    this.screenshotLines = this.lines.filter((l) => {
      return l.previewUrl !== null;
    });
  }

  get isEnglish() {
    return this.quotation.language.shortName == "en";
  }

  get lines() {
    const sortedList = [...this.revision.lines].sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
    return flatToTree(sortedList);
  }

  get company() {
    return this.quotation.company;
  }

  get hasScreenshot() {
    return this.screenshotLines.length > 0;
  }
}
